var CheckListItemStatus = /** @class */ (function () {
    function CheckListItemStatus(dto) {
        this.id = dto.id;
        this.name = dto.name;
    }
    return CheckListItemStatus;
}());
export default CheckListItemStatus;



//////////////////
// WEBPACK FOOTER
// ./src/models/CheckListItemStatus.ts
// module id = 362
// module chunks = 0